import { useState, useEffect } from "react";
import tryParseJSON from "./tryParseJSON";
import {AxiosResponse} from "axios";

type ApiResponse<T> = {
    data: T | null;
    setData: React.Dispatch<React.SetStateAction<T | null>>;
    loading: boolean;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    error: any;
    setError: React.Dispatch<React.SetStateAction<any>>;
    isError: boolean;
    setIsError: React.Dispatch<React.SetStateAction<boolean>>;
};

function useApi<T>(apiFunction: () => Promise<T>, dependencies: any[] = [], runCall: boolean = true): ApiResponse<T> {
    const [data, setData] = useState<T | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<any>(null);
    const [isError, setIsError] = useState(false);
    
    useEffect(() => {
        if (runCall) {
            // debugger
            setLoading(true);
            apiFunction()
                .then((response) => {
                    
                    if(typeof(response) == "string"){
                        
                       if( tryParseJSON(response) === false ){
                           setData(null);
                           setError(response);
                           setIsError(true);
                           console.log("useApi err response");
                           return;
                       }
                        
                    }
                    
                    setData(response);
                    setError(null);
                    console.log("useApi response");
                })
                .catch((err) => {
                    setError(err);
                    setIsError(true);
                    console.log("useApi err");
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, dependencies);

    return { data, setData, loading, setLoading, error, setError, isError, setIsError };
}

export default useApi;